import type { IconNode } from '../types';

/**
 * @name sushi-3
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgMTBhMiAyIDAgMCAxLTIgMmgtLjVsLTUuNi0xLjRjLTEuMS0uMy0yLjgtLjMtMy45IDBMNC40IDEySDRhMiAyIDAgMCAxLTItMiA0IDQgMCAwIDEgNC00aDEyYTQgNCAwIDAgMSA0IDQiIC8+CiAgPHBhdGggZD0ibTYgMTEgMS01IiAvPgogIDxwYXRoIGQ9Im0xMCAxMCAxLTQiIC8+CiAgPHBhdGggZD0ibTE0IDEwIDEtNCIgLz4KICA8cGF0aCBkPSJtMTggMTEgMS00IiAvPgogIDxwYXRoIGQ9Ik0yMCAxMnY0YTIgMiAwIDAgMS00IDAgMiAyIDAgMCAxLTQgMCAyIDIgMCAwIDEtNCAwIDIgMiAwIDAgMS00IDB2LTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/sushi-3
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sushi3: IconNode = [
  [
    'path',
    {
      d: 'M22 10a2 2 0 0 1-2 2h-.5l-5.6-1.4c-1.1-.3-2.8-.3-3.9 0L4.4 12H4a2 2 0 0 1-2-2 4 4 0 0 1 4-4h12a4 4 0 0 1 4 4',
      key: 'j9mryd',
    },
  ],
  ['path', { d: 'm6 11 1-5', key: 'cwbxhk' }],
  ['path', { d: 'm10 10 1-4', key: '1kne3t' }],
  ['path', { d: 'm14 10 1-4', key: '1m5jy6' }],
  ['path', { d: 'm18 11 1-4', key: '1usp0s' }],
  [
    'path',
    { d: 'M20 12v4a2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-4 0 2 2 0 0 1-4 0v-4', key: '1ba8yq' },
  ],
];

export default sushi3;
